import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../Components/Footer/Footer";
import ScrollToTop from "../Components/ScrollTop";

const RootLayOut = () => {
  return (
    <>
      <ScrollToTop />
      <Outlet />
      <Footer />
    </>
  );
};

export default RootLayOut;
